import getCacheKey from "@/vue/planning/logic/getCacheKey"
import responsesCache from "@/vue/planning/state/responsesCache"
import { getQuoteRequestData } from "@/vue/planning/logic/getRequestData"
import { PricesResponse } from "@/types/responses"
import * as _ from "lodash"
import { getUniqueId } from "@/vue/planning/logic/uniqueId"
import pricesLoadingSet from "@/vue/planning/state/pricesLoadingSet"

const getWiypPrice = async (
	packageId: string,
	packCode: string,
    liheId: string,
    prestIds: string,
	startDate: string,
	endDate: string,
	familyComposition: string,
	site: string,
    acceptLanguage: string, 
): Promise<void> => {
	if (packageId === "") throw new Error("cannot request prices without packageId")
	if (packCode === "HS") throw new Error("cannot request prices for HS package")
	if (prestIds === "") throw new Error("Cannot request without prestIds")
	if (familyComposition === "") throw new Error("family composition incorrect")

    const pricePromise: Promise<PricesResponse> = new Promise(async (resolve) => {
        const price_resp = await window.wiypService.getWiypPrices({packageId, packCode, liheId, prestIds, startDate, endDate, familyComposition, site, acceptLanguage});
		resolve(price_resp)
	})
	return
}

export default getWiypPrice
